// extracted by mini-css-extract-plugin
export default {"mini-image-card":"mini-image-card-5675","image-container":"image-container-9f6a","image":"image-29e5","info-container":"info-container-b46f","tag":"tag-72c6","title":"title-9c24"};